var map = {
	"./Contact.jsx": 8890,
	"./Discovery.jsx": 9098,
	"./Faq.jsx": 7427,
	"./Home.jsx": 4034,
	"./Layouts/MarketingLayout.jsx": 4088,
	"./Pricing.jsx": 2379,
	"./SolutionShow.jsx": 3195,
	"./Solutions.jsx": 675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5297;